export type ResponseResult = 'OK' | 'Error';

export type ResponseAttributes = {
  ErrorMsg?: string;
  ErrorNum?: number;
  Result: ResponseResult;
  Count?: number;
  ResultNumber?: number;
  ResultMsg?: string;
};

export type CoreSettingType = 'int' | 'string' | 'date' | ''; // empty since core requires type field but ignores its value in set requests

export type CorePhoneSettingItem = {
  PhoneSettingName: string;
  PhoneSettingType: CoreSettingType;
  PhoneSettingValue: string;
};

export type CoreUserSettingItem = {
  UserSettingName: string;
  UserSettingType: CoreSettingType;
  UserSettingValue: string;
};

export enum ResponseErrors {
  NotLoggedIn = 1,
  UsernameOrPasswordIncorrect = 2,
  NonExistentPhoneNumber = 3,
  UniqueIDNotRecognized = 11,
  PhoneNumberNotRegistered = 12,
  UniqueIdAlreadyExists = 13,
  SignMailServerUnavailable = 14,
  UniqueIdNull = 17,
  ProvisionRequestFailed = 30,
  EmergencyStatusNotFound = 31,
  NoEmergencyAddress = 32,
  AddressDataBlank = 33,
  DatabaseError = 35,
  QueryMachineError = 41,
  QueryConnectorUnreachable = 42,
  QueryConnectorNotDeclared = 43,
  EndpointTypeMismatch = 48,
  BlockListErrorWhiteListed = 49,
  PhoneTypeNotRecognized = 52,
  MismatchingURIorPriorities = 55,
  UriCouldNotBeDeleted = 56,
  UriCouldNotBeAdded = 57,
  CannotRegisterForSignmail = 58,
  MaxContactQuota = 59,
  IndeterminantLogin = 60,
  LogInAsInvalid = 61,
  AliasUpdateError = 62,
  RingGroupCreateError = 63,
  InvalidPin = 64,
  UnableToCreateRingGroup = 65,
  NotRingGroupCapable = 66,
  CallListItemInvalid = 67,
  EnumUpdateError = 69,
  CallListItemDoesNotExist = 70,
  NoInviteFound = 72,
  NotInARinGroup = 73,
  ThisUserCannotBeInvited = 74,
  UnableToInviteUser = 75,
  RingGroupDoesNotExist = 76,
  GroupPhoneNumberNotFound = 77,
  RingGroupInviteAcceptError = 78,
  RingGroupInviteRejectError = 79,
  GroupPhoneNumberEmpty = 80,
  DescriptionUnder50chars = 81,
  UserNotFound = 82,
  RingGroupUserRemoveError = 86,
  UserInThisRingGroup = 87,
  InvalidPhoneNumber = 88,
  BlockRingGroupMemberError = 90,
  CannotRemoveLastRingGroupUser = 91,
  TrsUriRequired = 92,
  InvalidURI = 93,
  InvalidGroupCredentials = 99,
  NotInThisRingGroup = 100,
  RingGroupPasswordSetError = 101,
  PhoneNumberEmpty = 102,
  RingGroupInfoSetError = 103,
  DialStringRequired = 104,
  CannotRemoveRingGroupCreator = 105,
  ImageNotFound = 106,
  NoUserAgreementFound = 107,
  InvalidRegistrationData = 108,
  ErrorUpdatingUserAgreement = 109,
  RequiredParameterMissing = 110,
  ContactIdORError = 111,
  CoreConfigurationError = 112,
  ErrorRemovingImage = 113,
  UnableToSetSetting = 114,
  InvalidDialType = 115,
  InvalidPhoneType = 116,
  InvalidPosition = 117,
  InvalidFavoriteType = 118,
  FavoriteTypeEmpty = 119,
  PositionEmpty = 120,
  DoubleFavoriteError = 121,
  PublicIdEmpty = 122,
  FavoriteQuotaMet = 123,
  LoginNotAllowed = 124,
  InvalidUniqueID = 125,
  NameFieldsEmpty = 126,
  ContactDoesNotExist = 128,
  FavoriteItemDoesNotExist = 129,
  FavoritesNotEnabled = 130,
  InvalidBlockCallerId = 134,
  InvalidRingColor = 135,
  StatusIsInvalid = 138,
}
